export const VOICE_ERROR_KEYS = {
  fairUse: 'errors:voice.fairUse',
  unavailable: 'errors:voice.unavailable',
  unreadable: 'errors:voice.unreadable',
} as const;

export type VoiceErrorKey =
  (typeof VOICE_ERROR_KEYS)[keyof typeof VOICE_ERROR_KEYS];

export const VOICE_TRANSCRIPT_MAX_CHARS = 600;
export const VOICE_MEMBERS_MAX = 200;
/** The API's user-name cap; an imported or placeholder name can run longer. */
export const VOICE_MEMBER_NAME_MAX = 100;
export const VOICE_DESCRIBE_CLIENT_TIMEOUT_MS = 25_000;
